const CONFIG = {
  API_BASE_URL: 'https://restaurant-api.dicoding.dev',
  API_KEY: 'testing',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/',

  DATABASE_NAME: 'restaurant-catalogue-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
